export default __webpack_public_path__ + "static/media/sv.d9ce8ed0.svg";